module.exports = __webpack_public_path__ + "img/katharma.703a8f91.png";